import { Fragment } from "react";

import { ChevronRight, Home } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);

  // Don't show on home page
  if (paths.length === 0) return null;

  const labels = {
    studio: "My Studio",
    "agent-artifacts": "My Studio",
    agent: "Agent",
    hivemind: "Hivemind",
    settings: "Settings",
    chat: "Chat",
  };

  return (
    <nav className="flex items-center gap-2 text-xs text-slate-400 mb-4 animate-fade-in px-1">
      <Link
        to="/"
        className="hover:text-indigo-500 transition-colors bg-white dark:bg-slate-800 p-1 rounded shadow-sm border border-slate-200 dark:border-slate-700 block"
      >
        <Home className="w-3 h-3" />
      </Link>
      {paths.map((path, i) => (
        <Fragment key={path}>
          <ChevronRight className="w-3 h-3 text-slate-300" />
          <Link
            to={`/${paths.slice(0, i + 1).join("/")}`}
            className={`capitalize transition-colors px-2 py-0.5 rounded ${i === paths.length - 1 ? "font-bold text-slate-700 dark:text-slate-200 bg-slate-100 dark:bg-slate-800" : "hover:text-indigo-500 hover:bg-white dark:hover:bg-slate-800"}`}
          >
            {labels[path] || path.replace(/_/g, " ")}
          </Link>
        </Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
